<ng-container *ngIf="showBanner$ | async">
  <div class="opt-suspended-banner-wrapper">
    <div class="container">
      <div class="opt-suspended-banner" role="alert">
        <div class="opt-suspended-banner__content">
          <!-- Line 1: Heading with icon -->
          <div class="opt-suspended-banner__heading-row">
            <div class="opt-suspended-banner__icon" aria-hidden="true">
              <span class="opt-suspended-banner__icon-i">i</span>
            </div>
            <h2 class="opt-suspended-banner__heading">{{ heading }}</h2>
          </div>
          <!-- Line 2: Message -->
          <p class="opt-suspended-banner__message">{{ message }}</p>
          <!-- Line 3: Button -->
          <div class="opt-suspended-banner__action">
            <button type="button" class="opt-suspended-banner__btn" (click)="goToMyBookings()">
              My Bookings
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
